import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useWalletsControllerAddCustomWallet } from '~/lib/api';
import { getReadableAddress } from '~/lib/get-readable-address';

export function useConnectUserWallet() {
  const [tonConnectUI] = useTonConnectUI();
  const queryClient = useQueryClient();
  const wallet = useTonWallet();

  const { mutate: addCustomWallet } = useWalletsControllerAddCustomWallet({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries();
      },
    },
  });

  useEffect(() => {
    const unsubscribe = tonConnectUI.onStatusChange((wallet) => {
      if (wallet) {
        addCustomWallet({ data: { address: wallet.account.address } });
      }
    });

    return () => {
      unsubscribe();
    };
  }, [tonConnectUI, addCustomWallet]);

  return {
    connectedWallet: wallet,

    formatReadableAddress() {
      if (!wallet) {
        return '';
      }

      return getReadableAddress(wallet.account.address, 6, -4);
    },
    openConnectUI: () => {
      void tonConnectUI.openModal();
    },
  };
}
